// src/routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AuthLayout, MainLayout } from '../components/common/Layout';
import RequireAuth from '../components/common/RequireAuth/RequireAuth';
import { hasRouteAccess } from '../utils/routeUtils';
import { ROUTES } from '../utils/constants';

// Page Imports
import Login        from '../pages/auth/Login';
import Dashboard    from '../pages/Dashboard';
import Profile      from '../pages/Profile';
import Products     from '../pages/Products';
import Customers    from '../pages/Customers';
import Deposits     from '../pages/Deposits';
import Withdrawals  from '../pages/Withdrawals';
import Games        from '../pages/Games';
import Users        from '../pages/Users';
import Referral     from '../pages/Referral';
import Retention    from '../pages/Retention';
import Points       from '../pages/Points';
import Jackpot     from '../pages/Jackpot';
import ReferralAnalytics from '../pages/ReferralAnalytics';
import DepositReconcile from '../pages/DepositReconcile';
import AdminSettings from '../pages/AdminSettings';
import NotFound     from '../pages/errors/NotFound';
import Unauthorized from '../pages/errors/Unauthorized';
import { USER_ROLES } from '../utils/constants';

const routeConfigs = [
  { path: ROUTES.DASHBOARD,  element: <Dashboard /> },
  { path: ROUTES.PROFILE,    element: <Profile /> },
  { path: ROUTES.PRODUCTS,   element: <Products /> },
  { path: ROUTES.CUSTOMERS,  element: <Customers /> },
  { path: ROUTES.DEPOSITS,   element: <Deposits /> },
  { path: ROUTES.WITHDRAWALS,element: <Withdrawals /> },
  { path: ROUTES.GAMES,      element: <Games /> },
  { path: ROUTES.USERS,      element: <Users /> },
  { path: ROUTES.REFERRAL,   element: <Referral /> },
  { path: ROUTES.RETENTION,  element: <Retention /> },
  { path: ROUTES.POINTS,     element: <Points /> },
  {
    path: ROUTES.JACKPOT,
    element: (
      <RequireAuth requiredRole={USER_ROLES.SUPER_ADMIN}>
        <Jackpot />
      </RequireAuth>
    ),
  },
  { path: ROUTES.REFERRAL_ANALYTICS, element: <ReferralAnalytics /> },
  {
    path: ROUTES.DEPOSIT_RECONCILE,
    element: (
      <RequireAuth requiredRole={USER_ROLES.SUPER_ADMIN}>
        <DepositReconcile />
      </RequireAuth>
    ),
  },
  {
    path: ROUTES.ADMIN_SETTINGS,
    element: (
      <RequireAuth requiredRole={USER_ROLES.SUPER_ADMIN}>
        <AdminSettings />
      </RequireAuth>
    ),
  },
];

const AppRoutes = () => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);

  /* 👇 ALWAYS send authenticated users to /dashboard */
  const DEFAULT_AFTER_LOGIN = ROUTES.DASHBOARD;

  return (
    <Routes>
      {/* ───────────── PUBLIC AUTH ROUTES ───────────── */}
      <Route
        path={ROUTES.LOGIN}
        element={
          isAuthenticated
            ? <Navigate to={DEFAULT_AFTER_LOGIN} replace />
            : <AuthLayout><Login /></AuthLayout>
        }
      />
      <Route
        path={ROUTES.REGISTER}
        element={<Navigate to={isAuthenticated ? DEFAULT_AFTER_LOGIN : ROUTES.LOGIN} replace />}
      />

      {/* ───────────── PROTECTED APP ROUTES ───────────── */}
      <Route
        path="/*"
        element={
          <RequireAuth>
            <MainLayout>
              <Routes>
                {routeConfigs.map(({ path, element }) =>
                  hasRouteAccess(role, path) ? (
                    <Route key={path} path={path.substring(1)} element={element} />
                  ) : null
                )}

                {/* Root inside the app → /dashboard */}
                <Route path="/" element={<Navigate to={DEFAULT_AFTER_LOGIN} replace />} />

                {/* Error / fallback */}
                <Route path="unauthorized" element={<Unauthorized />} />
                <Route path="404"          element={<NotFound />} />
                <Route path="*"            element={<Navigate to="/404" replace />} />
              </Routes>
            </MainLayout>
          </RequireAuth>
        }
      />

      {/* ───────────── GLOBAL FALLBACK ───────────── */}
      <Route
        path="*"
        element={
          <Navigate
            to={isAuthenticated ? DEFAULT_AFTER_LOGIN : ROUTES.LOGIN}
            replace
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;


// // src/routes/AppRoutes.jsx

// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { AuthLayout, MainLayout } from '../components/common/Layout';
// import RequireAuth from '../components/common/RequireAuth/RequireAuth';
// import { hasRouteAccess, getDefaultRoute } from '../utils/routeUtils';
// import { ROUTES } from '../utils/constants';

// // Page Imports
// import Login from '../pages/auth/Login';
// import Register from '../pages/auth/Register';
// import Dashboard from '../pages/Dashboard';
// import Profile from '../pages/Profile';
// import Products from '../pages/Products';
// import Customers from '../pages/Customers';
// import Deposits from '../pages/Deposits';
// import Withdrawals from '../pages/Withdrawals';
// import Games from '../pages/Games';
// import Users from '../pages/Users';
// import NotFound from '../pages/errors/NotFound';
// import Unauthorized from '../pages/errors/Unauthorized';
// import Referral from '../pages/Referral';


// const routeConfigs = [
//   { path: ROUTES.DASHBOARD, element: <Dashboard /> },
//   { path: ROUTES.PROFILE, element: <Profile /> },
//   { path: ROUTES.PRODUCTS, element: <Products /> },
//   { path: ROUTES.CUSTOMERS, element: <Customers /> },
//   { path: ROUTES.DEPOSITS, element: <Deposits /> },
//   { path: ROUTES.WITHDRAWALS, element: <Withdrawals /> },
//   { path: ROUTES.GAMES, element: <Games /> },
//   { path: ROUTES.USERS, element: <Users /> },
//   { path: ROUTES.REFERRAL, element: <Referral /> },
// ];

// const AppRoutes = () => {
//   // ✅ FIX: Remove the `loading` state from the selector. It's not needed here.
//   const { isAuthenticated, role } = useSelector((state) => state.auth);

//   // ✅ FIX: REMOVED the `if (loading)` block entirely.
//   // This will stop the page from unmounting.

//   const userDefaultRoute = role ? getDefaultRoute(role) : ROUTES.LOGIN;

//   return (
//     <Routes>
//       {/* AUTHENTICATION ROUTES (Public) */}
//       <Route
//         path={ROUTES.LOGIN}
//         element={isAuthenticated ? <Navigate to={userDefaultRoute} replace /> : <AuthLayout><Login /></AuthLayout>}
//       />
//       <Route
//         path={ROUTES.REGISTER}
//         element={isAuthenticated ? <Navigate to={userDefaultRoute} replace /> : <AuthLayout><Register /></AuthLayout>}
//       />

//       {/* PROTECTED APPLICATION ROUTES */}
//       <Route
//         path="/*"
//         element={
//           <RequireAuth>
//             <MainLayout>
//               <Routes>
//                 {routeConfigs.map(({ path, element }) => 
//                   hasRouteAccess(role, path) ? (
//                     <Route key={path} path={path.substring(1)} element={element} />
//                   ) : null
//                 )}

//                 <Route path="/" element={<Navigate to={userDefaultRoute} replace />} />
//                 <Route path="unauthorized" element={<Unauthorized />} />
//                 <Route path="404" element={<NotFound />} />
                
//                 <Route path="*" element={<Navigate to="/404" replace />} />
//               </Routes>
//             </MainLayout>
//           </RequireAuth>
//         }
//       />
      
//       {/* GLOBAL FALLBACK */}
//       <Route path="*" element={<Navigate to={isAuthenticated ? userDefaultRoute : ROUTES.LOGIN} replace />} />
//     </Routes>
//   );
// };

// export default AppRoutes;

// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { AuthLayout, MainLayout } from '../components/common/Layout';
// import RequireAuth from '../components/common/RequireAuth/RequireAuth';
// import { hasRouteAccess, getDefaultRoute } from '../utils/routeUtils';
// import { ROUTES } from '../utils/constants';

// // Page Imports
// import Login from '../pages/auth/Login';
// import Register from '../pages/auth/Register';
// import Dashboard from '../pages/Dashboard';
// import Profile from '../pages/Profile';
// import Products from '../pages/Products';
// import Customers from '../pages/Customers';
// import Deposits from '../pages/Deposits';
// import Withdrawals from '../pages/Withdrawals';
// import Games from '../pages/Games';
// import Users from '../pages/Users';
// import NotFound from '../pages/errors/NotFound';
// import Unauthorized from '../pages/errors/Unauthorized';

// // Centralized route configuration defines all possible protected routes.
// // Access is handled dynamically below.
// const routeConfigs = [
//   { path: ROUTES.DASHBOARD, element: <Dashboard /> },
//   { path: ROUTES.PROFILE, element: <Profile /> },
//   { path: ROUTES.PRODUCTS, element: <Products /> },
//   { path: ROUTES.CUSTOMERS, element: <Customers /> },
//   { path: ROUTES.DEPOSITS, element: <Deposits /> },
//   { path: ROUTES.WITHDRAWALS, element: <Withdrawals /> },
//   { path: ROUTES.GAMES, element: <Games /> },
//   { path: ROUTES.USERS, element: <Users /> },
//   // Add other routes like ADMIN_DASHBOARD here if they have corresponding pages
// ];

// const AppRoutes = () => {
//   const { isAuthenticated, loading, role } = useSelector((state) => state.auth);

//   if (loading) {
//     return null; // Or a loading spinner component
//   }

//   const userDefaultRoute = role ? getDefaultRoute(role) : ROUTES.LOGIN;

//   return (
//     <Routes>
//       {/* AUTHENTICATION ROUTES (Public) */}
//       <Route
//         path={ROUTES.LOGIN}
//         element={isAuthenticated ? <Navigate to={userDefaultRoute} replace /> : <AuthLayout><Login /></AuthLayout>}
//       />
//        <Route
//         path={ROUTES.REGISTER}
//         element={isAuthenticated ? <Navigate to={userDefaultRoute} replace /> : <AuthLayout><Register /></AuthLayout>}
//       />

//       {/* PROTECTED APPLICATION ROUTES */}
//       <Route
//         path="/*"
//         element={
//           <RequireAuth>
//             <MainLayout>
//               <Routes>
//                 {/* Dynamically create routes based on the user's role */}
//                 {routeConfigs.map(({ path, element }) => 
//                   hasRouteAccess(role, path) ? (
//                     <Route key={path} path={path.substring(1)} element={element} />
//                   ) : null
//                 )}

//                 {/* Root redirect and error pages */}
//                 <Route path="/" element={<Navigate to={userDefaultRoute} replace />} />
//                 <Route path="unauthorized" element={<Unauthorized />} />
//                 <Route path="404" element={<NotFound />} />
                
//                 {/* Fallback for any other protected route that doesn't match */}
//                 <Route path="*" element={<Navigate to="/404" replace />} />
//               </Routes>
//             </MainLayout>
//           </RequireAuth>
//         }
//       />
      
//       {/* GLOBAL FALLBACK (for non-matching, non-protected routes) */}
//       <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
//     </Routes>
//   );
// };

// export default AppRoutes;


// // ====================================
// // src/routes/AppRoutes.jsx
// // ====================================
// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import RequireAuth, { 
//   RequireAdmin, 
//   RequireManagerOrAdmin,
//   RequireNLAAdmin 
// } from '../components/common/RequireAuth/RequireAuth';
// import { AuthLayout, MainLayout } from '../components/common/Layout';
// import { 
//   hasRouteAccess, 
//   getDefaultRoute, 
//   meetsMinimumRoleRequirement 
// } from '../utils/routeUtils';

// // Auth pages
// import Login from '../pages/auth/Login';
// import Register from '../pages/auth/Register';

// // Main pages
// import Dashboard from '../pages/Dashboard';
// import Products from '../pages/Products';
// import Customers from '../pages/Customers';
// import Profile from '../pages/Profile'; 
// import Deposits from '../pages/Deposits';
// import Withdrawals from '../pages/Withdrawals';
// import Games from '../pages/Games';
// import Users from '../pages/Users';

// // Error pages
// import NotFound from '../pages/errors/NotFound';
// import Unauthorized from '../pages/errors/Unauthorized';

// import { ROUTES, USER_ROLES } from '../utils/constants';

// const AppRoutes = () => {
//   const { isAuthenticated, loading, role } = useSelector((state) => state.auth);

//   if (loading) {
//     return null;
//   }

//   const createProtectedRoute = (path, element, requiredRoles = null, minimumRole = null) => {
//     const routePath = path.replace('/', '');
    
//     if (role && !hasRouteAccess(role, path)) {
//       return (
//         <Route 
//           key={path}
//           path={routePath} 
//           element={<Navigate to="/unauthorized" replace />} 
//         />
//       );
//     }

//     if (requiredRoles) {
//       return (
//         <Route 
//           key={path}
//           path={routePath} 
//           element={
//             <RequireAuth requiredRoles={requiredRoles}>
//               {element}
//             </RequireAuth>
//           } 
//         />
//       );
//     }

//     if (minimumRole) {
//       const hasMinimumRole = meetsMinimumRoleRequirement(path, role);
//       if (!hasMinimumRole) {
//         return (
//           <Route 
//             key={path}
//             path={routePath} 
//             element={<Navigate to="/unauthorized" replace />} 
//           />
//         );
//       }
//     }

//     return (
//       <Route 
//         key={path}
//         path={routePath} 
//         element={element} 
//       />
//     );
//   };

//   const routeConfigs = [
//     {
//       path: ROUTES.DASHBOARD,
//       element: <Dashboard />,
//       description: 'Dashboard - accessible to all authenticated users'
//     },

//      {
//       path: ROUTES.PROFILE,
//       element: <Profile />,
//       description: 'Dashboard - accessible to all authenticated users'
//     },
//     {
//       path: ROUTES.PRODUCTS,
//       element: <Products />,
//       requiredRoles: [USER_ROLES.JOURNALIST, USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.INFLUENCER, USER_ROLES.NLA_ADMIN],
//       description: 'Products - Journalist and above'
//     },
//     {
//       path: ROUTES.CUSTOMERS,
//       element: <Customers />,
//       requiredRoles: [USER_ROLES.JOURNALIST, USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.INFLUENCER, USER_ROLES.NLA_ADMIN],
//       description: 'Customers - Journalist and above'
//     },
//     {
//       path: ROUTES.DEPOSITS,
//       element: <Deposits />,
//       requiredRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//       description: 'Deposits - StationManager and above'
//     },
//     {
//       path: ROUTES.WITHDRAWALS,
//       element: <Withdrawals />,
//       requiredRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//       description: 'Withdrawals - StationManager and above'
//     },
//     {
//       path: ROUTES.GAMES,
//       element: <Games />,
//       requiredRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//       description: 'Games - StationManager and above'
//     },
//     {
//       path: ROUTES.USERS,
//       element: <Users />,
//       requiredRoles: [USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//       description: 'Users - Admin only'
//     }
//   ];

//   const userDefaultRoute = role ? getDefaultRoute(role) : ROUTES.DASHBOARD;

//   return (
//     <Routes>
//       <Route 
//         path={ROUTES.LOGIN} 
//         element={
//           isAuthenticated ? (
//             <Navigate to={userDefaultRoute} replace />
//           ) : (
//             <AuthLayout>
//               <Login />
//             </AuthLayout>
//           )
//         } 
//       />
      
//       <Route 
//         path={ROUTES.REGISTER} 
//         element={
//           isAuthenticated ? (
//             <Navigate to={userDefaultRoute} replace />
//           ) : (
//             <AuthLayout>
//               <Register />
//             </AuthLayout>
//           )
//         } 
//       />

//       <Route 
//         path="/" 
//         element={
//           <Navigate 
//             to={isAuthenticated ? userDefaultRoute : ROUTES.LOGIN} 
//             replace 
//           />
//         } 
//       />

//       <Route
//         path="/*"
//         element={
//           <RequireAuth>
//             <MainLayout>
//               <Routes>
//                 {routeConfigs.map(config => 
//                   createProtectedRoute(
//                     config.path, 
//                     config.element, 
//                     config.requiredRoles,
//                     config.minimumRole
//                   )
//                 )}

//                 {hasRouteAccess(role, '/nla-admin') && (
//                   <Route 
//                     path="nla-admin/*" 
//                     element={
//                       <RequireNLAAdmin>
//                         <Routes>
//                           {/* <Route path="dashboard" element={<div>NLA Admin Dashboard</div>} /> */}
//                           {/* <Route path="system-config" element={<div>System Config</div>} /> */}
//                           <Route path="*" element={<Navigate to="dashboard" replace />} />
//                         </Routes>
//                       </RequireNLAAdmin>
//                     } 
//                   />
//                 )}

//                 <Route path="unauthorized" element={<Unauthorized />} />
//                 <Route path="404" element={<NotFound />} />

//                 <Route 
//                   path="*" 
//                   element={<Navigate to={userDefaultRoute} replace />} 
//                 />
//               </Routes>
//             </MainLayout>
//           </RequireAuth>
//         }
//       />

//       <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
//     </Routes>
//   );
// };

// export default AppRoutes;


// // src/routes/AppRoutes.jsx
// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import RequireAuth, { 
//   RequireAdmin, 
//   RequireManagerOrAdmin,
//   RequireNLAAdmin 
// } from '../components/common/RequireAuth/RequireAuth';
// import { AuthLayout, MainLayout } from '../components/common/Layout';

// // Auth pages
// import Login from '../pages/auth/Login';
// import Register from '../pages/auth/Register';

// // Main pages
// import Dashboard from '../pages/Dashboard';
// import Products from '../pages/Products';
// import Customers from '../pages/Customers';
// import Deposits from '../pages/Deposits';
// import Withdrawals from '../pages/Withdrawals';
// import Games from '../pages/Games';
// import Users from '../pages/Users';
// // import Profile from '../pages/Profile';

// // Admin pages
// // import AdminDashboard from '../pages/admin/AdminDashboard';
// // import SystemSettings from '../pages/admin/SystemSettings';

// // Error pages
// // import NotFound from '../pages/errors/NotFound';
// // import Unauthorized from '../pages/errors/Unauthorized';

// import { ROUTES } from '../utils/constants';

// const AppRoutes = () => {
//   const { isAuthenticated, loading } = useSelector((state) => state.auth);

//   // Show loading while auth state is being determined
//   if (loading) {
//     return null; // or a loading spinner
//   }

//   return (
//     <Routes>
//       {/* Auth routes - redirect to dashboard if already authenticated */}
//       <Route 
//         path={ROUTES.LOGIN} 
//         element={
//           isAuthenticated ? (
//             <Navigate to={ROUTES.DASHBOARD} replace />
//           ) : (
//             <AuthLayout>
//               <Login />
//             </AuthLayout>
//           )
//         } 
//       />
      
//       <Route 
//         path={ROUTES.REGISTER} 
//         element={
//           isAuthenticated ? (
//             <Navigate to={ROUTES.DASHBOARD} replace />
//           ) : (
//             <AuthLayout>
//               <Register />
//             </AuthLayout>
//           )
//         } 
//       />

//       {/* Root redirect */}
//       <Route 
//         path="/" 
//         element={
//           <Navigate 
//             to={isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN} 
//             replace 
//           />
//         } 
//       />

//       {/* Protected routes with main layout */}
//       <Route
//         path="/*"
//         element={
//           <RequireAuth>
//             <MainLayout>
//               <Routes>
//                 {/* Dashboard - accessible to all authenticated users */}
//                 <Route 
//                   path={ROUTES.DASHBOARD.replace('/', '')} 
//                   element={<Dashboard />} 
//                 />

//                 {/* Profile - accessible to all authenticated users
//                 // <Route 
//                 //   path={ROUTES.PROFILE?.replace('/', '') || 'profile'} 
//                 //   element={<Profile />} 
//                 // /> */}

//                 {/* Business routes - role-based access */}
                
//                 {/* Journalist and above can access these */}
//                 <Route 
//                   path={ROUTES.PRODUCTS?.replace('/', '') || 'products'} 
//                   element={
//                     <RequireAuth requiredRoles={['Journalist', 'StationManager', 'Admin', 'Influencer', 'NLAADMIN']}>
//                       <Products />
//                     </RequireAuth>
//                   } 
//                 />

//                 <Route 
//                   path={ROUTES.CUSTOMERS?.replace('/', '') || 'customers'} 
//                   element={
//                     <RequireAuth requiredRoles={['Journalist', 'StationManager', 'Admin', 'Influencer', 'NLAADMIN']}>
//                       <Customers />
//                     </RequireAuth>
//                   } 
//                 />

//                 {/* StationManager and above can access these */}
//                 <Route 
//                   path={ROUTES.DEPOSITS?.replace('/', '') || 'deposits'} 
//                   element={
//                     <RequireManagerOrAdmin>
//                       <Deposits />
//                     </RequireManagerOrAdmin>
//                   } 
//                 />

//                 <Route 
//                   path={ROUTES.WITHDRAWALS?.replace('/', '') || 'withdrawals'} 
//                   element={
//                     <RequireManagerOrAdmin>
//                       <Withdrawals />
//                     </RequireManagerOrAdmin>
//                   } 
//                 />

//                 <Route 
//                   path={ROUTES.GAMES?.replace('/', '') || 'games'} 
//                   element={
//                     <RequireManagerOrAdmin>
//                       <Games />
//                     </RequireManagerOrAdmin>
//                   } 
//                 />

//                 {/* Admin only routes */}
//                 <Route 
//                   path={ROUTES.USERS?.replace('/', '') || 'users'} 
//                   element={
//                     <RequireAdmin>
//                       <Users />
//                     </RequireAdmin>
//                   } 
//                 />

//                 {/* <Route 
//                   path="admin/dashboard" 
//                   element={
//                     <RequireAdmin>
//                       <AdminDashboard />
//                     </RequireAdmin>
//                   } 
//                 /> */}

//                 {/* <Route 
//                   path="admin/settings" 
//                   element={
//                     <RequireAdmin>
//                       <SystemSettings />
//                     </RequireAdmin>
//                   } 
//                 /> */}

//                 {/* NLA Admin only routes */}
//                 <Route 
//                   path="nla-admin/*" 
//                   element={
//                     <RequireNLAAdmin>
//                       <Routes>
//                         {/* <Route path="dashboard" element={<NLAAdminDashboard />} />
//                         <Route path="system-config" element={<SystemConfig />} /> */}
//                         <Route path="*" element={<Navigate to="dashboard" replace />} />
//                       </Routes>
//                     </RequireNLAAdmin>
//                   } 
//                 />

//                 {/* Error pages */}
//                 {/* <Route path="unauthorized" element={<Unauthorized />} />
//                 <Route path="404" element={<NotFound />} /> */}

//                 {/* Catch all route - redirect to dashboard for authenticated users */}
//                 <Route 
//                   path="*" 
//                   element={<Navigate to={ROUTES.DASHBOARD} replace />} 
//                 />
//               </Routes>
//             </MainLayout>
//           </RequireAuth>
//         }
//       />

//       {/* Final catch-all for any unmatched routes */}
//       <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
//     </Routes>
//   );
// };

// export default AppRoutes;






// // src/routes/AppRoutes.jsx
// // Double-check your AppRoutes.jsx imports - should be:
// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import RequireAuth from '../components/common/RequireAuth';
// import { AuthLayout, MainLayout } from '../components/common/Layout';
// import Login from '../pages/auth/Login';
// import Register from '../pages/auth/Register';
// import Dashboard from '../pages/Dashboard';
// import Products from '../pages/Products';
// import Customers from '../pages/Customers';
// import Deposits from '../pages/Deposits';
// import Withdrawals from '../pages/Withdrawals';
// import Games from '../pages/Games';
// import Users from '../pages/Users';
// import { ROUTES } from '../utils/constants';

// const AppRoutes = () => {
//   const { isAuthenticated } = useSelector((state) => state.auth);

//   return (
//     <Routes>
//       {/* Auth routes - redirect to dashboard if already authenticated */}
//       <Route 
//         path={ROUTES.LOGIN} 
//         element={
//           isAuthenticated ? (
//             <Navigate to={ROUTES.DASHBOARD} replace />
//           ) : (
//             <AuthLayout>
//               <Login />
//             </AuthLayout>
//           )
//         } 
//       />
//       <Route 
//         path={ROUTES.REGISTER} 
//         element={
//           isAuthenticated ? (
//             <Navigate to={ROUTES.DASHBOARD} replace />
//           ) : (
//             <AuthLayout>
//               <Register />
//             </AuthLayout>
//           )
//         } 
//       />

//       {/* Protected routes with main layout */}
//       <Route
//         path="/*"
//         element={
//           <RequireAuth>
//             <MainLayout>
//               <Routes>
//                 <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
//                 <Route path={ROUTES.PRODUCTS} element={<Products />} />
//                 <Route path={ROUTES.CUSTOMERS} element={<Customers />} />
//                 <Route path={ROUTES.DEPOSITS} element={<Deposits />} />
//                 <Route path={ROUTES.WITHDRAWALS} element={<Withdrawals />} />
//                 <Route path={ROUTES.GAMES} element={<Games />} />
//                 <Route 
//                   path={ROUTES.USERS} 
//                   element={
//                     <RequireAuth requiredRole="admin">
//                       <Users />
//                     </RequireAuth>
//                   } 
//                 />
//                 {/* Catch all route */}
//                 <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
//               </Routes>
//             </MainLayout>
//            </RequireAuth>
//         }
//       />
//     </Routes>
//   );
// };

// export default AppRoutes;